import React from 'react'
import "./home.scss";
import TopDashboard from '../../components/dashboard/TopDashboard';
import { useEffect } from 'react';
import { useState } from 'react';
import axios from 'axios';

const Home = () => {

  return (
    <div className="main_wrp" style={{ backgroundColor: "white" }}>
      <div className="dash_b_wrp">
        <TopDashboard />
        <div>
          
        </div>

      </div>
    </div>
  );
}

export default Home
